import { render, staticRenderFns } from "./SkillDashboard.vue?vue&type=template&id=a826f5ba&"
import script from "./SkillDashboard.vue?vue&type=script&lang=js&"
export * from "./SkillDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SkillDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports